import { InvoiceDocument } from 'store/invoices/invoices.types'

const getLoadConfirmationSequence = (document: InvoiceDocument): number => {
  const fields = [document.documentName, document.originalName, document.s3Path]
  let maxSequence = -1

  for (const value of fields) {
    const matches = value.match(/LC_(\d+)/gi) ?? []
    for (const match of matches) {
      const seq = Number(match.replace(/[^0-9]/g, ''))
      if (Number.isFinite(seq)) {
        maxSequence = Math.max(maxSequence, seq)
      }
    }
  }

  return maxSequence
}

export const getLatestLoadConfirmationDocument = (
  documents: InvoiceDocument[] | undefined
): InvoiceDocument | undefined => {
  if (!documents?.length) return undefined

  return [...documents].sort((a, b) => {
    const sequenceDiff = getLoadConfirmationSequence(b) - getLoadConfirmationSequence(a)
    if (sequenceDiff !== 0) return sequenceDiff
    return a.documentName.localeCompare(b.documentName)
  })[0]
}

export const getLatestLoadConfirmationS3Path = (
  documents: InvoiceDocument[] | undefined
): string => getLatestLoadConfirmationDocument(documents)?.s3Path ?? ''
